module.exports = __webpack_public_path__ + "static/img/kbzlhxmk.831308e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/kbzlhxmk.png
// module id = igCU
// module chunks = 0